module.exports = __webpack_public_path__ + "677555cf9a42e2e82fb99716c15b9d47.pdf";